import {initForm} from "../inits/_form.init.js";
import {
  initBackgroundGridAnimation,
  initFooterC2aAnimation,
  refreshAllScrollTriggers
} from "../inits/_animatons.init.js";


document.querySelectorAll('[data-form-id]').forEach(eventForm => {
  initForm(`[data-form-id="${eventForm.getAttribute('data-form-id')}"]`);
});

(() => {
  initBackgroundGridAnimation()
  initFooterC2aAnimation();
  refreshAllScrollTriggers();
})();


window.addEventListener('resize', () => {
  refreshAllScrollTriggers();
}, {passive: true});
